import { render } from "./ArrowExpand.vue?vue&type=template&id=1239671e"
import script from "./ArrowExpand.vue?vue&type=script&lang=js"
export * from "./ArrowExpand.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__